export default __webpack_public_path__ + "uploads-blue-icon.svg";